import React from "react";
import Skeleton from "@oxygen/core/lib/SkeletonLoader/Skeleton";
import getThemeClasses from "@oxygen/theme";

const DealerInfoLoader = () => {
  return (
    <Skeleton height={190}>
      <rect x="0" y="0" width="100%" height="75%" />
      <rect x="5%" y="80%" rx="2" ry="2" width="28%" height="10%" />
      <rect x="5%" y="93%" rx="2" ry="2" width="41%" height="7%" />
    </Skeleton>
  );
};
const DealerOptionsLoader = () => {
  return (
    <>
      <Skeleton height={66}>
        <rect x="5%" y="0" rx="2" ry="2" width="11%" height="67%" />
        <rect x="5%" y="80%" rx="2" ry="2" width="11%" height="20%" />
        <rect x="27%" y="0" rx="2" ry="2" width="11%" height="67%" />
        <rect x="27%" y="80%" rx="2" ry="2" width="11%" height="20%" />
        <rect x="49%" y="0" rx="2" ry="2" width="11%" height="67%" />
        <rect x="49%" y="80%" rx="2" ry="2" width="11%" height="20%" />
      </Skeleton>
    </>
  );
};
const DealerUspLoader = () => {
  return (
    <Skeleton height={115}>
      <rect x="5%" y="11%" rx="2" ry="2" width="4%" height="15%" />
      <rect x="12%" y="13%" rx="2" ry="2" width="40%" height="12%" />
      <rect x="5%" y="42%" rx="2" ry="2" width="4%" height="15%" />
      <rect x="12%" y="44%" rx="2" ry="2" width="40%" height="12%" />
      <rect x="5%" y="73%" rx="2" ry="2" width="4%" height="15%" />
      <rect x="12%" y="75%" rx="2" ry="2" width="40%" height="12%" />
    </Skeleton>
  );
};
const DealerGalleryLoader = () => {
  return (
    <Skeleton height={330}>
      <rect x="5%" y="0" rx="2" ry="2" width="24%" height="7%" />
      <rect x="5%" y="11%" rx="3" ry="3" width="91%" height="87%" />
    </Skeleton>
  );
};

const loaderClasses = getThemeClasses(`
  mb-4;
  width-full;
`);
const dealersUspLoaderClasses = getThemeClasses(`
  mt-4;
  mb-5;
  width-full;
  bg-whiteSmokeLight;
`);
const dealerGalleryLoaderClasses = getThemeClasses(`
  mb-3;
  mt-6;
  width-full;
`);
const DealerMicrositeSkeletonLoader = () => {
  return (
    <>
      <div className={loaderClasses}>
        <DealerInfoLoader />
      </div>
      <div className={loaderClasses}>
        <DealerOptionsLoader />
      </div>
      <div className={dealersUspLoaderClasses}>
        <DealerUspLoader />
      </div>
      <div className={dealerGalleryLoaderClasses}>
        <DealerGalleryLoader />
      </div>
    </>
  );
};

export default DealerMicrositeSkeletonLoader;
